import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface CountdownTimerProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
}
export function CountdownTimer({
  initialHours = 1,
  initialMinutes = 30,
  initialSeconds = 24
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const totalSeconds = initialHours * 3600 + initialMinutes * 60 + initialSeconds;
    let currentSeconds = totalSeconds;
    const timer = setInterval(() => {
      currentSeconds--;
      if (currentSeconds < 0) {
        currentSeconds = totalSeconds; // Reset
      }
      setTimeLeft({
        hours: Math.floor(currentSeconds / 3600),
        minutes: Math.floor(currentSeconds % 3600 / 60),
        seconds: currentSeconds % 60
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [initialHours, initialMinutes, initialSeconds]);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const TimeUnit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-246">
      <div className="bg-navy-900 border border-navy-700/50 rounded-lg p-3 md:p-4 min-w-[70px] md:min-w-[90px] flex justify-center items-center shadow-inner relative overflow-hidden" data-id="element-247">
        <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none" data-id="element-248" />
        <AnimatePresence mode="popLayout" data-id="element-249">
          <motion.span key={value} initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: -20,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="font-anton text-3xl md:text-5xl text-gold-500 tracking-wider" data-id="element-250">
            {formatNumber(value)}
          </motion.span>
        </AnimatePresence>
      </div>
      <span className="text-xs md:text-sm font-oswald uppercase tracking-widest text-gray-400 mt-2" data-id="element-251">
        {label}
      </span>
    </div>;
  return <div className="flex items-center justify-center gap-2 md:gap-4" data-id="element-252">
      <TimeUnit value={timeLeft.hours} label="Hours" data-id="element-253" />
      <span className="text-2xl md:text-4xl font-anton text-navy-700 pb-6" data-id="element-254">
        :
      </span>
      <TimeUnit value={timeLeft.minutes} label="Minutes" data-id="element-255" />
      <span className="text-2xl md:text-4xl font-anton text-navy-700 pb-6" data-id="element-256">
        :
      </span>
      <TimeUnit value={timeLeft.seconds} label="Seconds" data-id="element-257" />
    </div>;
}